export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const PROJECT_LOADING = 'PROJECT_LOADING';
export const PROJECT_LOADED = 'PROJECT_LOADED';
export const PROJECT_LOADED_JOIN = 'PROJECT_LOADED_JOIN';
export const PROJECT_FAILED = 'PROJECT_FAILED';
export const SECTION_LOADED = 'SECTION_LOADED';
export const UPLOAD_UPDATED = 'UPLOAD_UPDATED';
